module.exports = __webpack_public_path__ + "media/images/delivery-box-4f02c4c8e0fe906d539024beb95af721.png";